import { render, staticRenderFns } from "./PazaramaKategori.vue?vue&type=template&id=c0f69648&scoped=true&"
import script from "./PazaramaKategori.vue?vue&type=script&lang=js&"
export * from "./PazaramaKategori.vue?vue&type=script&lang=js&"
import style0 from "./PazaramaKategori.vue?vue&type=style&index=0&id=c0f69648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f69648",
  null
  
)

export default component.exports